/* global __NODE__ */

import get from 'lodash/get';
import { rocConfig } from 'roc-package-web-app-react/app/shared/universal-config';
import { appConfig as clientConfig } from 'roc-package-web-app-react/app/shared';

const adPlacements = {
    desktop: {
        netboard_1: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_2: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_3: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_4: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_5: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
    },
    tablet: {
        netboard_1: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_2: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
        netboard_3: {
            sizes: [
                [580, 400],
                [580, 500],
                [560, 400],
                [1, 1],
            ],
        },
    },
    mobile: {
        board_1: {
            sizes: [
                [320, 250],
                [300, 250],
                [320, 200],
                [320, 400],
                [1, 1],
            ],
        },
        board_2: {
            sizes: [
                [320, 250],
                [300, 250],
                [320, 200],
                [320, 400],
                [1, 1],
            ],
        },
        board_3: {
            sizes: [
                [320, 250],
                [300, 250],
                [320, 200],
                [320, 400],
                [1, 1],
            ],
        },
        board_4: {
            sizes: [
                [320, 250],
                [300, 250],
                [320, 200],
                [320, 400],
                [1, 1],
            ],
        },
        board_5: {
            sizes: [
                [320, 250],
                [300, 250],
                [320, 200],
                [320, 400],
                [1, 1],
            ],
        },
    },
};

export const options = {
    desktop: 'netboard_1',
    tablet: 'netboard_1',
    mobile: 'board_1',
};

export const adConfig = {
    debug: false,
    astUrl: '//acdn.adnxs.com/ast/static/0.7.3/ast.js',
    invCodePrefix: 'no-e24',
    lazyload: true,
    threshold: 150,
    thresholdAbove: 100,
    thresholdRefresh: 300,
    thresholdAboveRefresh: 300,
    aboveTheFold: false,
    disableInactiveRender: true,
    defaultPage: 'article',
    defaultOptions: {
        member: 3296,
        disablePsa: true,
        noBidIfUnsold: true,
    },
    defaultKeywords: {
        'aa-sch-country_code': 'no',
        'aa-sch-publisher': 'e24',
        'aa-sch-inventory_type': 'editorial',
        'no-sno-publishergroup': 'schibsted',
    },
    placements: {
        desktop: adPlacements.desktop,
        tablet: adPlacements.tablet,
        mobile: adPlacements.mobile,
    },
};

/* @TODO Add more breakpoints when Bors is expanded to desktop & tablet */
export const breakpoints = {
    mobile: {
        small: 350,
        normal: 500,
    },
    tablet: 1024,
};

const port = __NODE__ && parseInt(process.env.PORT, 10) || get(rocConfig, 'runtime.port', 3000);
export const baseUrl = __NODE__ ? `http://localhost:${port}/api` : '/api';

export const icons = {
    usd: ['0 0'],
    eur: ['-32px 0'],
    gbp: ['-64px 0'],
    jpy: ['-96px 0'],

    brent: ['-0 -32px'],
    gold: ['-32px -32px'],
    silver: ['-64px -32px'],

    bitcoin: ['0 -64px'],
    ethereum: ['-32px -64px'],
    xrp: ['-64px -64px'],
    litecoin: ['-96px -64px'],
};

export default clientConfig;



/** WEBPACK FOOTER **
 ** /src/shared/config.js
 **/